// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"6ea407bd","702":"5dcaaaf7"}[chunkId] + ".chunk.js";
};